"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const react_syntax_highlighter_1 = require("react-syntax-highlighter");
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const jsx_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/jsx"));
const bash_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/bash"));
const css_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/css"));
const markup_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/markup"));
const tsx_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/tsx"));
const typescript_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/typescript"));
const ActionBar_1 = __importDefault(require("../ActionBar"));
const languages_1 = __importDefault(require("./languages"));
const ScrollArea_1 = __importDefault(require("../ScrollArea"));
const Pre_1 = __importDefault(require("../Pre/Pre"));
const codeStyle_1 = __importDefault(require("./codeStyle"));
react_syntax_highlighter_1.PrismLight.registerLanguage("jsx", jsx_1.default);
react_syntax_highlighter_1.PrismLight.registerLanguage("bash", bash_1.default);
react_syntax_highlighter_1.PrismLight.registerLanguage("css", css_1.default);
react_syntax_highlighter_1.PrismLight.registerLanguage("html", markup_1.default);
react_syntax_highlighter_1.PrismLight.registerLanguage("tsx", tsx_1.default);
react_syntax_highlighter_1.PrismLight.registerLanguage("typescript", typescript_1.default);
const Wrapper = styled_components_1.default.div `
  ${({ theme, bordered }) => (0, styled_components_1.css) `
    position: relative;
    overflow: hidden;
    color: ${bitcoincom_pkg_theme_1.colors.solid.white};
    margin-bottom: ${theme.spacing.unit * 3}px;
    ${bordered
    ? (0, styled_components_1.css) `
          border: ${theme.border.solid.default} ${theme.palette.border.default};
          border-radius: ${theme.border.radius.medium}px;
          background-color: ${bitcoincom_pkg_theme_1.colors.solid.comet};
        `
    : (0, styled_components_1.css) ``}
  `}
`;
const CodeElement = styled_components_1.default.code({
    flex: 1,
    paddingRight: 0,
    opacity: 1,
});
/**
 * Syntax highlighter for code styles extended and styled PrismLight
 *
 * from [React Syntax Highlighter](https://github.com/conorhastings/react-syntax-highlighter)
 */
const Code = (props) => {
    const { language = "javascript", children, code, useInlineStyles = true, copyable = true, bordered = true, padded = false, maxHeight, className = null } = props, rest = __rest(props, ["language", "children", "code", "useInlineStyles", "copyable", "bordered", "padded", "maxHeight", "className"]);
    const [copied, setCopied] = (0, react_1.useState)(false);
    const onClick = (e) => {
        e.preventDefault();
        const tmp = document.createElement("textarea");
        const focus = document.activeElement;
        tmp.value = (children === null || children === void 0 ? void 0 : children.toString()) || "";
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand("copy");
        document.body.removeChild(tmp);
        if (focus)
            focus.focus();
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1500);
    };
    return children || code ? (react_1.default.createElement(Wrapper, { bordered: bordered, padded: padded, className: className },
        react_1.default.createElement(ScrollArea_1.default, { style: { maxHeight } },
            react_1.default.createElement(react_syntax_highlighter_1.PrismLight, Object.assign({ padded: padded || bordered, language: language, useInlineStyles: useInlineStyles, PreTag: Pre_1.default, CodeTag: CodeElement, style: (0, codeStyle_1.default)({ padded }), customStyle: { fontSize: 16 }, lineNumberContainerStyle: {
                    paddingRight: 16,
                    color: bitcoincom_pkg_theme_1.colors.solid.vulcanLightest,
                } }, rest), children)),
        copyable && (react_1.default.createElement(ActionBar_1.default, { actionItems: [{ title: copied ? "Copied" : "Copy", onClick }] })))) : null;
};
exports.Code = Code;
exports.Code.displayName = "Code";
exports.Code.Languages = languages_1.default;
exports.default = exports.Code;
//# sourceMappingURL=Code.js.map